import classnames from 'classnames';

/** The What's New beta colour, as a small pill beside a name. */
const BetaBadge = ({ className }: { className?: string }) => (
  <span
    className={classnames(
      'rounded-full bg-secondary-600 px-1.5 py-0.5 text-[10px] font-bold uppercase leading-none tracking-wide text-white',
      className
    )}
  >
    Beta
  </span>
);

export default BetaBadge;
